// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1f3Jc","list":"BalanceDue_list__1Xn4c","listRow":"BalanceDue_listRow__MtzIo","total":"BalanceDue_total__2Xe1S"};